// extracted by mini-css-extract-plugin
module.exports = {"circularProgress":"circular-progress_circularProgress__R_7Xe","progressText":"circular-progress_progressText__RAbrB"};